import { render, staticRenderFns } from "./Drug.vue?vue&type=template&id=24501e0a&scoped=true"
import script from "./Drug.vue?vue&type=script&lang=js"
export * from "./Drug.vue?vue&type=script&lang=js"
import style0 from "./Drug.vue?vue&type=style&index=0&id=24501e0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24501e0a",
  null
  
)

export default component.exports